import React, { ReactElement } from 'react'

import { NextPage } from 'app/types/decalarations/next'

import MainLayout from '~/components/layouts/MainLayout'
import AuthTrianglesContainer from '~/components/layouts/TrianglesContainer'
import SignUpView from '~/views/Auth/SignUpView'

const SignUpPage: NextPage = () => <SignUpView />

SignUpPage.getLayout = (page: ReactElement) => (
  <MainLayout>
    <AuthTrianglesContainer>{page}</AuthTrianglesContainer>
  </MainLayout>
)

SignUpPage.getMeta = (intl) => ({
  title: intl.formatMessage({
    defaultMessage: 'Sign-Up'
  }),
  description: intl.formatMessage({
    defaultMessage: 'Create a new IFnd account.'
  })
})

export default SignUpPage
